import BaseComponent from '@/components/base';
import { style } from './style';

export default class Dropdown extends BaseComponent {
  onConstruct() {
    this.selectedOption = null;
    this.chevron = null;
  }

  render() {
    return `
      ${style}
      <section>
        <ul class="close">
          <chevron-button style="
            position: absolute;
            right: 10px;
            top: 21px;
            cursor: pointer;"
          >
          </chevron-button>
          ${this.data.options.value
            .map(
              ({ text, value, description, imgUrl, isDefault }) =>
                `<li value="${value}" ${isDefault ? 'class="selected"' : ''} >
                <div
                  style="
                    min-width: 84px;
                    height: 63px;
                    background: url('${imgUrl}') lightgray 50% / cover no-repeat;
                    background-size: ${
                      this.getAttribute('fullWidthImg')
                        ? '100%'
                        : this.handleCheckIfIsFragranceOrScalpType(value)
                          ? '70%'
                          : '100%'
                    }
                    127%;
                    background-position: center;
                    background-color: #D2EAE5;
                      "
                ></div>
                <div>
                  <span class="title">${text}</span>
                  <span class="description">${
                    description ? description : ''
                  }</span>
                <div>
              </li>`
            )
            .join('')}
        </ul>
      </section>
    `;
  }

  afterMount() {
    const defaultData = this.data.options.value.find((x) => x.isDefault);
    if (defaultData) {
      const defaultElement = this.shadowRoot.querySelector(
        `li[value="${defaultData.value}"]`
      );
      this.selectedOption = defaultElement;
    } else {
      const firsOption = this.shadowRoot.querySelector('li');
      firsOption.classList.add('selected');
      this.selectedOption = firsOption;
    }

    this.chevron = this.shadowRoot.querySelector('chevron-button');
    this.chevron.handleClick = () => {
      this.toggleDropdown();
    };

    this.shadowRoot
      .querySelectorAll('li')
      .forEach((li) =>
        li.addEventListener('click', () => this.handleButtonClick(li))
      );
  }

  handleCheckIfIsFragranceOrScalpType(value) {
    const fragranceOrScalpTypes = new Set([
      'floret',
      'vanilla suede',
      'coco',
      'rose',
      'fragrance-free',
      'normal',
      'dry',
      'oily'
    ]);
    return fragranceOrScalpTypes.has(value);
  }

  handleButtonClick(li) {
    if (this.selectedOption) {
      this.selectedOption.classList.remove('selected');
    }

    this.selectedOption = li;
    this.selectedOption.classList.add('selected');

    const selectedValue = this.selectedOption.getAttribute('value');
    this.setAttribute('value', selectedValue);

    this.dispatchEvent(
      new CustomEvent('selectedDropDown', {
        detail: { value: selectedValue },
        bubbles: true,
        composed: true
      })
    );

    this.toggleDropdown();
  }

  toggleDropdown() {
    const ulElement = this.shadowRoot.querySelector('ul');
    if (ulElement) {
      ulElement.classList.toggle('close');
      this.chevron.toggleArrow();
    }
  }

  get selectedValue() {
    return this.shadowRoot.querySelector('li.selected').getAttribute('value');
  }
}
